import CryptoJS from 'crypto-js';

export default {
    md5Handle(msg) {
        return CryptoJS.MD5(msg);
    },
    aesHandle(msg, key, ivStr) {
        return CryptoJS.enc.Base64.stringify(CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(msg), CryptoJS.enc.Utf8.parse(key), { iv: CryptoJS.enc.Utf8.parse(ivStr), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).ciphertext);
    },
    aesdHandle(msg, key, ivStr) {
        return CryptoJS.enc.Utf8.stringify(CryptoJS.AES.decrypt(msg, CryptoJS.enc.Utf8.parse(key), { iv: CryptoJS.enc.Utf8.parse(ivStr), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }));
    }
}